<template>
    <div class="lancamentos">
        <div v-if="loader" class="column align-center justify-center">
            <Loader layout="small" />
        </div>
        <template v-else>
            <div class="container" v-if="lancamentos.length > 0">
                <div class="row title">
                    <div class="id grid-1 text-center">ID</div>
                    <div class="grid-2">Atendimento</div>
                    <div class="grid-2">Supporter</div>
                    <div class="grid-2">Data</div>
                    <div class="grid-2">Histórico</div>
                    <div class="grid-2">Tipo</div>
                    <div class="grid-1">KM</div>
                    <div class="grid-2">R$ Supporter</div>
                    <div class="grid-2">R$ Cliente</div>
                    <div class="grid-2">Estornável?</div>
                    <div class="grid-1" style="min-width: 100px"></div>
                </div>
                <div v-for="a in lancamentos" class="row line align-center" :key="a.id">
                    <div class="id grid-1">{{ a.id }}</div>
                    <div class="grid-2">{{ a.id_atendimento }}</div>
                    <div class="grid-2 fp">{{ a.nome_doutor }}</div>
                    <div class="grid-2">{{ a.criado_em | date }}</div>
                    <div class="grid-2">{{ a.historico }}</div>
                    <div class="grid-2" style="text-transform: capitalize;">{{ a.tipo_lancamento.replace('_', " ") }}</div>
                    <div class="g1">{{ a.km_total && a.km_total > 0 ? a.km_total: "0" }}</div>
                    <div class="grid-2">{{ a.valor_doutor | money }}</div>
                    <div class="grid-2">{{ a.valor_cliente | money }}</div>
                    <div class="grid-2">{{ a.estornavel ? 'Sim' : 'Não' }}</div>
                    <div class="grid-1"><Button v-if="!a.estornado && a.estornavel" layout="green-go"
                            @click="estornar(a.id)" :loader="bloader">Estornar</Button><span v-else>Estornado</span>
                    </div>
                </div>
            </div>
            <div class="no" v-else>NÃO POSSUI LANÇAMENTOS.</div>
        </template>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Vue from "vue";
import Loader from "@/components/Loader";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

export default {
    name: "Lancamentos",
    components: { Button, Loader },
    props: { job: Object },
    data() {
        return {
            loader: true,
            bloader: false,
            lancamentos: [],
        };
    },
    methods: {
        ...mapActions("admin", ["LANCAMENTOS", "ESTORNAR"]),
        async load() {
            this.loader = true;
            await this.LANCAMENTOS(this.job.id).then(({ data }) => this.lancamentos = data || []);
            this.loader = false
        },
        async estornar(ID) {
            if (confirm("Deseja estornar esse lançamento?")) {
                this.bloader = true;
                await this.ESTORNAR({ job: this.job.id, id: ID });
                this.bloader = false;
                this.load()
            }
        },

    },
    beforeMount() {
        this.load()
    }
};
</script>

<style lang="sass" scoped>
  @use "@/assets/scss/vars.scss" as *
  .lancamentos
    padding: 10px 30px
    padding-bottom: 40px
    overflow: auto
    .fp
        font-size: 14px
    .container
        min-width: 1400px
        border-radius: 16px
        overflow: hidden
        .id
            min-width: 33px
        .line
            padding: 10px
            font-size: 16px
            &:nth-child(odd)
                background: #eee
            span
                color: $purple
                font-size: 14px

    .title
        font-weight: bold
        padding: 16px 0
        opacity: .6
        background: $purple
        color: white
        font-size: 14px
    .no
        color: $gray-1
        font-size: 16px
        padding: 30px 60px
  
  </style>


<!-- {
"estornado": false,
"estornavel": true,

"id": 5,
"id_atendimento": 10,
"id_job": 10,
"km_total": null,
"mensagem": null,
"nome_doutor": "Brunno Supporter",
"notificado": false,
"quem": "Brunno Cruvinel Fraga",
"tipo_lancamento": "reembolso_ns",
"valor_cliente": 0.0,
"valor_doutor": 12.32
} -->